"use strict";
exports.__esModule = true;
var translations = {
    "else": "undefined."
};
exports["default"] = translations;
//# sourceMappingURL=undefined.js.map